import { Account, Location } from "@/api/opb/opbTypes";
import AutoPayTag from "@/components/AutoPayTag";

interface OptionProps {
  location?: Location;
  account: Account;
}

function Option(props: OptionProps) {
  const { location, account } = props;

  return (
    <div className="flex min-w-0 max-w-full items-center whitespace-nowrap">
      <div
        className="mr-2 min-w-0 flex-1 overflow-hidden text-ellipsis"
        title={location ? `${location.city} — ${location.name}` : account.name}
      >
        {location ? `${location?.city} — ${location?.name}` : account.name}
      </div>
      <span className="shrink-0">
        <AutoPayTag
          isAutoPayOn={account.autopay}
          hasDefaultPaymentMethod={Boolean(account.defaultPaymentMethodId)}
        />
      </span>
    </div>
  );
}

export default Option;
